import custom from './custom'

export default {
    supplier: {
        url: `${custom.appUrl}/compras/proveedores`,
        valueAttribute: 'nombre',
        labelAttribute: 'nombre',
        auth: {
            url: `${custom.appUrl}/api/sap/access_token`,
            clientId: 'ae297ffe549eea8bb846ea29',
            clientSecret: '407a57b407841480e7977df5',
            grantType: 'client_credentials',
        }
    },
    crossing: {
        valueAttribute: 'cruceid',
        labelAttribute: 'cruce',
        auth: {
            url: `${custom.appUrl}/api/sap/access_token`,
            clientId: 'ae297ffe549eea8bb846ea29',
            clientSecret: '407a57b407841480e7977df5',
            grantType: 'client_credentials',
        }
    },
    internalOrder: {
        url: `${custom.appUrl}/orden_interna/search`,
    },
    avatar: {
        url: `${custom.appUrl}/resources/users/images`,
    }
}


// WEBPACK FOOTER //
// ./src/config/apis.js